import { IHallBookingBill } from "src/domain/entities"
import { hallBookingBillAddApi } from "../../api/hallBookingBill/hallBookingBillAddApi"

type PayloadShape = Parameters<typeof hallBookingBillAddApi>[0]

export async function hallBookingBillAddService(
	payload: PayloadShape,
	token?: null | string,
) {
	const hallBookingBill = await hallBookingBillAddApi(payload, token)
	return hallBookingBill as NonNullable<IHallBookingBill>
}
